import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

const CalendarioVencido = ({ ilustracion = false }) => (
  <svg viewBox="0 0 120 120" width="100%" height="100%" fill="none" aria-hidden="true">
    {ilustracion && <circle cx="60" cy="60" r="57" fill="#DDF6FC" />}
    <g transform={ilustracion ? "rotate(-12 60 60)" : undefined}>
      <rect
        x="26"
        y="31"
        width="68"
        height="65"
        rx="9"
        fill="#F5FCFF"
        stroke={ilustracion ? "#A5E2F2" : "#29B8D7"}
        strokeWidth="7"
      />
      <path d="M27 48H93" stroke={ilustracion ? "#A5E2F2" : "#29B8D7"} strokeWidth="8" />
      <path
        d="M42 22V36M78 22V36"
        stroke={ilustracion ? "#8ED6E9" : "#29B8D7"}
        strokeWidth="7"
        strokeLinecap="round"
      />
      {ilustracion ? (
        <>
          <path d="M40 62H49M40 78H49M57 62H66" stroke="#DAF3FB" strokeWidth="9" />
          <circle cx="80" cy="77" r="20" fill="#FF6A84" stroke="#F5FCFF" strokeWidth="4" />
          <path d="M74 71L86 83M86 71L74 83" stroke="white" strokeWidth="4" strokeLinecap="round" />
        </>
      ) : (
        <path d="M50 63L70 83M70 63L50 83" stroke="#29B8D7" strokeWidth="7" strokeLinecap="round" />
      )}
    </g>
    {ilustracion && (
      <path
        d="M105 36L110 30M109 48L116 47M108 60L114 64"
        stroke="#FF6A84"
        strokeWidth="4"
        strokeLinecap="round"
      />
    )}
  </svg>
);

CalendarioVencido.propTypes = { ilustracion: PropTypes.bool };

export default function ReservaVencidaAviso({ mensaje }) {
  // Conserva también la fecha cuando la API informa un vencimiento de otro día.
  const vencimiento = mensaje.match(/^(.*?)\s+(\d{2}:\d{2})\.?$/);

  return (
    <Box
      role="alert"
      sx={{
        width: "100%",
        minWidth: 0,
        textAlign: "left",
        p: { xs: 2, sm: 2.5 },
        borderRadius: "16px",
        border: "1px solid #D0EDF8",
        background: "linear-gradient(135deg, #F2FBFF 0%, #ECF9FF 100%)",
        boxShadow: "0 3px 12px rgba(36, 139, 174, 0.06)",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Box
          sx={{
            display: "flex",
            flexShrink: 0,
            alignItems: "center",
            justifyContent: "center",
            width: { xs: 42, sm: 50 },
            height: { xs: 42, sm: 50 },
            p: 0.5,
            borderRadius: "50%",
            bgcolor: "#D6F5FD",
          }}
        >
          <CalendarioVencido />
        </Box>
        <Typography
          component="h3"
          sx={{
            color: "#092B42",
            fontSize: { xs: "1.125rem", sm: "1.3rem" },
            fontWeight: 800,
            lineHeight: 1.25,
            letterSpacing: "-0.025em",
          }}
        >
          Reserva vencida
        </Typography>
      </Box>

      <Box sx={{ mt: 2, pt: 2, borderTop: "1px solid #D8EFF8" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              component="p"
              sx={{ color: "#496072", fontSize: "0.95rem", lineHeight: 1.5 }}
            >
              {vencimiento ? `${vencimiento[1]} ` : mensaje}
            </Typography>
            {vencimiento && (
              <Box
                component="span"
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.75,
                  mt: 1,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: "999px",
                  bgcolor: "#FFE1EB",
                  color: "#C51148",
                  fontSize: "1.25rem",
                  fontWeight: 800,
                  lineHeight: 1.4,
                  fontVariantNumeric: "tabular-nums",
                  whiteSpace: "nowrap",
                }}
              >
                <svg width="21" height="21" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
                  <path
                    d="M12 6.5V12L16 14.5"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {vencimiento[2]}
              </Box>
            )}
          </Box>
          <Box
            aria-hidden="true"
            sx={{
              flexShrink: 0,
              width: "24%",
              maxWidth: 88,
              minWidth: 40,
              aspectRatio: "1",
              opacity: 0.85,
            }}
          >
            <CalendarioVencido ilustracion />
          </Box>
        </Box>
        <Typography
          component="p"
          sx={{
            mt: 1.75,
            color: "#496072",
            fontSize: "0.95rem",
            lineHeight: 1.6,
            maxWidth: "30ch",
          }}
        >
          Ya no se puede generar el QR para este pedido.
        </Typography>
      </Box>
    </Box>
  );
}

ReservaVencidaAviso.propTypes = { mensaje: PropTypes.string.isRequired };
